var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.764,
    height: 15.777,
    viewBox: "0 0 16.764 15.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chart-pie",
    "data-name": "Icon awesome-chart-pie",
    d: "M16.264,8.875H8.952l4.87,4.87a.494.494,0,0,0,.684.021,7.38,7.38,0,0,0,2.254-4.341.494.494,0,0,0-.495-.55Zm-.488-2A7.413,7.413,0,0,0,8.9,0a.5.5,0,0,0-.518.5V7.4h6.9a.5.5,0,0,0,.5-.518Zm-8.874,2V1.563a.494.494,0,0,0-.55-.495A7.39,7.39,0,0,0,0,8.64a7.487,7.487,0,0,0,7.485,7.137,7.338,7.338,0,0,0,4.168-1.357.49.49,0,0,0,.048-.742Z",
    transform: "translate(0 0)",
    fill: "#6f109e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.23f47f11a8e9b62be9fa25b9c29a741a.svg";
export { ForwardRef as ReactComponent };